// 📁 src/components/CasePost.jsx
import { Link, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { FaCode } from "react-icons/fa";
import { MonoButton } from "../kits";

import { PaperDarkBG } from "../kits";
import CollapsibleCodeBlock_screen from "./CollapsibleCodeBlock_screen";
import Preloader from "./Preloader";
import RoughBorder from "../kits/LayoutKit/RoughBorder";
import { loadCase } from "../data/loadCase";

// andere Beiträge anzeigen

import CaseListCase from "./CaseListCase";

// Booking Tool 

import BookingModal from './BookingModal';

export default function CasePost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // Ref für das große Bild oben
  const mainImageRef = useRef(null);

  // Array-Ref für alle Content-Bilder
  const blockImageRefs = useRef([]);


  // Booking Modal O n Off 

    const [showBooking, setShowBooking] = useState(false);

  useEffect(() => {
    if (!slug) return;
    loadCase().then((cases) => {
      const found = cases.find((c) => c.slug === slug);
      if (found) setPost(found);
      else setError(true);
    }).catch((err) => { console.error(err); setError(true); })
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <Preloader isReady={!loading}>
      {error || (!loading && !post) ? (
        <div className="text-center text-sm text-gray-800 py-20">Kein Eintrag gefunden.</div>
      ) : post && (
    <PaperDarkBG className="sm:py-10">
      <div className="max-w-4xl w-full mx-auto pt-10 px-4 font-mono">
        <div className="rounded-lg overflow-hidden border border-[#2B2B2B] bg-[#1a1a1a] backdrop-blur-[2px]">
          <div className="px-3 sm:px-5 pt-3 sm:pt-2">
            <nav className="flex w-full gap-1 overflow-x-auto no-scrollbar pb-0">
            <Link
              to="/zenlab2"
              className="shrink-0 min-w-[128px] h-9 sm:h-10 px-3 rounded-t-2xl border border-b-0 border-[#2a2a2a] bg-[#1a1a1a] text-[#EFEBDC]/80 hover:border-[#AC8E66]/60 text-[10px] sm:text-[11px] tracking-[0.08em] font-mono flex items-center justify-center"
            >
              ZenLab
            </Link>
            <Link
              to="/zenlab2?tab=CaseStudy"
              className="shrink-0 min-w-[128px] h-9 sm:h-10 px-3 rounded-t-2xl border border-b-0 border-[#AC8E66]/70 bg-[#1a1a1a] text-[#EFEBDC]/80 text-[10px] sm:text-[11px] tracking-[0.08em] font-mono flex items-center justify-center"
            >
              CaseStudy
            </Link>
            <span
              className="shrink-0 min-w-[128px] h-9 sm:h-10 px-3 rounded-t-2xl border border-b-0 border-[#AC8E66] bg-[#dbd8cc]/95 text-[#111111] shadow-[0_10px_28px_rgba(0,0,0,0.28)] text-[10px] sm:text-[11px] tracking-[0.08em] font-mono flex items-center justify-center"
              aria-current="page"
            >
              {post.title}
            </span>
            </nav>
          </div>

        </div>
      </div>

      <article className="max-w-4xl w-full mx-auto mt-2 mb-10 px-4">
        <div className="mt-5"></div>

        {/* Hauptbild mit RoughBorder */}
        {post.image && (
          <div
            ref={mainImageRef}
            className="block w-full md:inline-block md:max-w-prose 
               px-4 py-4 shadow-lg relative -top-1"
          >
            <img
              src={post.image}
              alt={post.title}
              className="w-full object-cover rounded-md"
            />
            <RoughBorder
              parentRef={mainImageRef}
              radius={20}
              padding={2}
          color="#AC8E66" 
              strokeWidth={0.3}
              roughness={1}
              bowing={2}
            />
          </div>
        )}

        {/* Content Blocks */}
        {post.blocks && post.blocks.map((block, i) => {
          switch (block.type) {
            case "header":
              const Tag = `h${block.data.level}`;
              return (
                <div
                  key={i}
                  className="mt-8 mb-4 inline-block sm:block w-full rounded-lg px-4 py-2 relative -top-1 bg-[#d0cbb8]"
                >
                  <Tag className="flex items-center gap-2 font-mono text-sm text-shadow text-[#1a1a1a]">
                    <FaCode className="text-brand flex-shrink-0" />
                    <span>{block.data.text}</span>
                  </Tag>
                </div>
              );
            case "paragraph":
              return (
                <p key={i} className="mb-4 ml-4 leading-relaxed font-mono text-xs sm:text-sm">
                  {block.data.text}
                </p>
              );
            case "list": {
              const items = block.data.items;
              if (!Array.isArray(items) || items.length === 0) return null;
              if (typeof items[0] === "string") {
                if (block.data.style === "unordered") {
                  return (
                    <ul key={i} className="list-disc ml-8 mb-4  text-xs sm:text-sm">
                      {items.map((textItem, idx) => (
                        <li key={idx}>{textItem}</li>
                      ))}
                    </ul>
                  );
                } else {
                  return (
                    <ol key={i} className="list-decimal ml-6 mb-4">
                      {items.map((textItem, idx) => (
                        <li className="font-mono" key={idx}>{textItem}</li>
                      ))}
                    </ol>
                  );
                }
              }
              if (typeof items[0] === "object") {
                if (block.data.style === "unordered") {
                  return (
                    <ul key={i} className="list-disc ml-6 mb-4">
                      {items.map((itemObj, idx) => {
                        const text = itemObj.content ?? itemObj.text ?? "(kein Text)";
                        return <li className="font-mono text-xs" key={idx}>{text}</li>;
                      })}
                    </ul>
                  );
                } else {
                  return (
                    <ol key={i} className="list-decimal ml-6 mb-4">
                      {items.map((itemObj, idx) => {
                        const text = itemObj.content ?? itemObj.text ?? "(kein Text)";
                        return <li key={idx}>{text}</li>;
                      })}
                    </ol>
                  );
                }
              }
              return null;
            }
            case "quote":
              return (
                <blockquote key={i} className="
                border-l-4
                 border-brand 
                 pl-4 pr-2 py-4 italic mb-4 text-xs
                  text-brand font-mono mt-4 bg-gray-950">
                  <p>{block.data.text}</p>
                  {block.data.caption && (
                    <cite className="block text-right font-mono">
                      — {block.data.caption}
                    </cite>
                  )}
                </blockquote>
              );
            // Bild-Block mit RoughBorder + array-ref!
            case "image": {
              const src = block.data.file?.url || block.data.src;
              const alt = block.data.caption || block.data.alt || "Bild";
              if (!src) {
                return (
                  <div key={i} className="text-red-600 font-mono text-xs my-4">
                    ⚠️ Kein Bild gefunden im Block {i}
                    <pre>{JSON.stringify(block.data, null, 2)}</pre>
                  </div>
                );
              }
              return (
                <div
                  key={i}
                  ref={el => blockImageRefs.current[i] = el}
                  className="my-6 p-4 
                  bg-gradient-to-br from-gray-50   
                  px-4 py-4 shadow-lg relative -top-1"
                >
                  <img
                    src={src}
                    alt={alt}
                    className="w-full max-w-xl mx-auto rounded-md shadow-inherit"
                  />
                  {alt && (
                    <figcaption className="mt-2 text-xs text-center text-gray-600 font-mono">
                      {alt}
                    </figcaption>
                  )}
                  <RoughBorder
                    parentRef={{ current: blockImageRefs.current[i] }}
                    radius={10}
                    padding={2}
                   color="#AC8E66" 
                    strokeWidth={1.1}
                    roughness={2}
                    bowing={2}
                  />
                </div>
              );
            }
            case "code":
              return (
                <CollapsibleCodeBlock_screen code={block.data.code} language={block.data.language} key={i} />
              );
            case "delimiter":
              return <hr key={i} className="my-8 border-gray-900" />;
            case "embed":
              return (
                <div key={i} className="my-6 aspect-w-16 aspect-h-9">
                  <iframe
                    src={block.data.embed}
                    title={block.data.caption || `Embed-${i}`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="w-full h-full"
                  />
                </div>
              );
            case "checklist":
              return (
                <ul key={i} className="list-none ml-0 mb-4">
                  {block.data.items.map((item, idx) => (
                    <li key={idx} className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        checked={item.checked}
                        readOnly
                        className="mr-2"
                      />
                      <span>{item.text}</span>
                    </li>
                  ))}
                </ul>
              );
            case "cta":
              const mode = block.data.mode || "url";       // ✅ NEU
              const label = block.data.text || "Weiter";
              const url = (block.data.url || "#").trim();

              const handleClick = () => {
                if (mode === "booking") {
                  setShowBooking(true);                    // ✅ Booking öffnen
                } else if (url && url !== "#") {
                  window.open(url, "_blank", "noopener,noreferrer");
                }
              };

            return (
  <div key={i} className="my-6 text-center ">
    <MonoButton
      className="w-full text-xs px-2 py-1 pt-2 pb-2 text-shadow"
      onClick={() => {
        const mode = block.data.mode || "url";
        const url = (block.data.url || "#").trim();
        const label = block.data.label || ""; // Wird aktuell nicht verwendet – kannst du löschen, wenn unnötig

        if (mode === "booking") {
          setShowBooking(true); // Öffnet das Modal
        } else if (url && url !== "#") {
          window.open(url, "_blank", "noopener,noreferrer"); // Öffnet externen Link
        }
        // else-Zweig für z. B. "kein gültiger Modus oder keine Aktion" kannst du ergänzen
      }}
    >
      {block.data.text || "Weiter"}
    </MonoButton>
  </div>
);
            case "table":
              return (
                <table key={i} className="table-auto border-collapse mb-6">
                  <tbody>
                    {block.data.content.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => (
                          <td
                            key={cellIndex}
                            className="border px-4 py-2 text-left"
                          >
                            {cell}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              );
            default:
              return (
                <div key={i} className="mb-4 p-4 bg-brand border-l-4 border-brand">
                  <p className="text-sm text-yellow-800">
                    (Dieser Block‐Typ &quot;{block.type}&quot; wird noch nicht gerendert.)
                  </p>
                </div>


              );

           
          }
        })}
           {showBooking && <BookingModal onClose={() => setShowBooking(false)} />}
        <CaseListCase currentSlug={slug} max={3} />
      </article>
    </PaperDarkBG>
      )}
    </Preloader>
  );
}
